import { Box, IconButton, Typography } from '@mui/material';
import styled from 'styled-components';

import { BaseColorKey, NotifierColorKey, SubjectColorKey } from '../../theme';

interface ColorProps {
  color: BaseColorKey | SubjectColorKey | NotifierColorKey;
}

interface ContainerProps {
  $bare?: boolean;
  $width?: number;
}

// `$bare` strips the surface so self-contained content (an embedded page, an
// image) sits straight on the backdrop and supplies its own edges.
const Container = styled(Box)<ContainerProps>`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${({ $width }) => ($width !== undefined ? `${$width}px` : 'auto')};
    min-width: ${({ $bare }) => ($bare ? 'auto' : 'min(400px, 95%)')};
    max-width: 95%;
    background-color: ${({ theme, $bare }) =>
      $bare ? 'transparent' : theme.palette.backdrop.light};
    box-shadow: ${({ theme, $bare }) => ($bare ? 'none' : theme.shadows[24])};
    padding: ${({ theme, $bare }) => ($bare ? 0 : theme.spacing(3))};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    outline: none;
  }
`;

const CloseIconButton = styled(IconButton)`
  && {
    position: absolute;
    right: ${({ theme }) => theme.spacing(2)};
    top: ${({ theme }) => theme.spacing(2)};
  }
`;

const TitleContainer = styled.div<ColorProps>`
  color: ${({ theme, color }) => theme.palette[color].dark};
`;

const Title = styled(Typography)``;

const Description = styled(Typography).attrs({
  component: 'div',
})`
  && {
    margin-top: ${({ theme }) => theme.spacing(2)};
  }
`;

const ButtonBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

interface ChildBoxProps {
  $scrollY?: boolean;
  $bare?: boolean;
}

const ChildBox = styled.div<ChildBoxProps>`
  margin-top: ${({ theme, $bare }) => ($bare ? 0 : theme.spacing(2))};
  max-height: ${({ $scrollY }) => ($scrollY ? '80vh' : 'none')};
  /* auto, not scroll, so the native track only appears when content actually
     exceeds the max-height — no empty track on short modals. */
  overflow-y: ${({ $scrollY }) => ($scrollY ? 'auto' : 'visible')};
`;

export { ButtonBar, ChildBox, CloseIconButton, Container, Description, Title, TitleContainer };
